import React, { Component } from 'react';
import { api_url, headers } from '../../common/config';
import arrow from '../../assets/images/icons/arrow-left.svg';
import FooterLarge from '../../components/footer/FooterLarge.jsx';
import CardSlider from '../../components/blog-cards/CardSlider';
import { Link, withRouter, Redirect } from 'react-router-dom';
import filesize from 'filesize';
import Loader from 'react-loader-spinner';
import { withTranslation } from 'react-i18next';
import {
    FacebookShareButton,
    TelegramShareButton,
    TwitterShareButton,
    WhatsappShareButton,
} from 'react-share';

import {
    FacebookIcon,
    TelegramIcon,
    TwitterIcon,
    WhatsappIcon,
} from 'react-share';

class ArticlesAndResearch extends Component {
    constructor(props) {
        super(props);

        this.state = {
            id: this.props.match.params.id,
            uploaderNum: '',
            uploaderName: '',
            imageNum: null,
            image: null,
            response: null,
            title: '',
            en_itle: '',
            subTitle: '',
            en_subTitle: '',
            abstract: '',
            en_abstract: '',
            body: '',
            en_body: '',
            authorName: '',
            en_authorName: '',
            authorTitle: '',
            en_authorTitle: '',
            authorAvatarId: null,
            authorAvatar: '',
            fileNum: null,
            tags: [''],
            file: null,
            fileSize: 0,
            related: null,
            relTime: '00/00/00',
        };
    }

    fetchResources = () => {
        let url = '';

        if (this.props.match.params.type === 'research') {
            url = 'resources_page_research';
        } else if (this.props.match.params.type === 'educational') {
            url = 'resources_page_guides';
        } else if (this.props.match.params.type === 'article') {
            url = 'articles';
        }

        fetch(`${api_url}/autism/items/${url}/${this.state.id}`, {
            method: 'GET',
            // headers: headers,
        })
            .then((res) => res.json())
            .then((res) => {
                this.setState({
                    response: res.data,
                    title: res.data.title,
                    en_title: res.data.en_title,
                    subTitle: res.data.sub_title,
                    en_subTitle: res.data.en_sub_title,
                    abstract: res.data.abstract,
                    en_abstract: res.data.en_abstract,
                    body: res.data.body,
                    en_body: res.data.en_body,
                    authorName: res.data.author_name,
                    en_authorName: res.data.en_author_name,
                    authorTitle: res.data.author_title,
                    en_authorTitle: res.data.en_author_title,
                    authorAvatarId: res.data.author_avatar,
                    fileNum: res.data.attachment,
                    tags: res.data.tags,
                    en_tags: res.data.en_tags,
                    imageNum: res.data.image,
                    relTime: res.data.created_on,
                });
                this.getAuthorAvatar();
                this.getImage();
                this.getFile();
            });

        fetch(
            `${api_url}/autism/items/${url}?filter[status]=published&fields=*.*`,
            {
                method: 'GET',
                // headers: headers,
            }
        )
            .then((res) => res.json())
            .then((res) => {
                this.setState({
                    related: res.data,
                });
            });
    };

    componentDidMount = () => {
        window.scrollTo(0, 0);
        this.fetchResources();
    };

    componentDidUpdate(prevProps) {
        if (this.props.match.params.id !== prevProps.match.params.id) {
            window.scrollTo(0, 0);
            this.fetchResources();
        } else {
            return null;
        }
    }

    getAuthorAvatar = () => {
        if (this.state.authorAvatarId !== null) {
            fetch(`${api_url}/autism/files/${this.state.authorAvatarId}`, {
                method: 'GET',
                // headers: headers,
            })
                .then((res) => res.json())
                .then((res) => {
                    this.setState({
                        authorAvatar: res.data.data.full_url,
                    });
                });
        } else {
            console.log(this.state.authorAvatar + ' has no image');
        }
    };

    getImage = () => {
        if (this.state.imageNum !== null) {
            fetch(`${api_url}/autism/files/${this.state.imageNum}`, {
                method: 'GET',
                // headers: headers,
            })
                .then((res) => res.json())
                .then((res) => {
                    this.setState({
                        image: res.data.data.full_url,
                    });
                });
        } else {
            console.log(this.state.imageNum + ' has no image');
        }
    };

    getFile = () => {
        if (this.state.fileNum !== null) {
            fetch(`${api_url}/autism/files/${this.state.fileNum}`, {
                method: 'GET',
                // headers: headers,
            })
                .then((res) => res.json())
                .then((res) => {
                    this.setState({
                        file: res.data.data.full_url,
                        fileSize: res.data.filesize,
                    });
                });
        } else {
            console.log(this.state.fileNum + 'has no attachment');
        }
    };

    date = (date) => {
        let dateCreated = date.split(' ');
        return dateCreated[0];
    };

    static getDerivedStateFromProps(nextProps, prevState) {
        if (prevState.fileNum !== nextProps.match.params.id) {
            return { id: nextProps.match.params.id };
        } else return null;
    }

    render() {
        // console.log(this.props, this.state);
        const { t, i18n } = this.props;
        let cards = null;
        let temp_cards = ['', '', '', ''];
        if (this.state.related === null) {
            cards = temp_cards.map((card) => (
                <div className='articale_card'>
                    <div className='card_image'></div>
                    <div className='card_content'>
                        <div className='wrapper'></div>
                    </div>
                </div>
            ));
        } else {
            cards = this.state.related.map((rel) => (
                <div className='articale_card'>
                    <div className='card_image'>
                        <img
                            height='100%'
                            width='100%'
                            src={rel.image.data.full_url}
                        />
                    </div>
                    <div className='card_content'>
                        <Link
                            to={`/blog/${this.props.match.params.type}/${rel.id}`}
                            style={{
                                padding: '0 0 8px 8px',
                            }}
                            replace
                        >
                            <div className='wrapper'>
                                <p>{rel.author_name}</p>
                                <p>{this.date(rel.created_on)}</p>
                            </div>
                            <h2
                                style={{
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                }}
                            >
                                {rel.title}
                            </h2>
                            <h3>{rel.abstract}</h3>
                            {/* {rel.body}</h3> */}
                           <p className='more'> {t('keepReading')}
                            <img
                                src={arrow}
                                alt=''
                                className={`${
                                    i18n.language === 'en' ? 'flip' : ''
                                }`}
                            />
                            </p>
                        </Link>
                    </div>
                </div>
            ));
        }
        let url = window.location.href;
        return (
            <div id='articlesAndResearch'>
                <Link to='/blog' className='back'>
                    {i18n.language === 'ar' ? (
                        <img
                            src={arrow}
                            style={{
                                transform: 'rotate(180deg)',
                                filter: ' brightness(200%) ',
                            }}
                        />
                    ) : (
                        <img
                            src={arrow}
                            style={{
                                filter: ' brightness(200%) ',
                            }}
                        />
                    )}
                    <p>{t('back')}</p>
                </Link>
                <div
                    className='header'
                    style={{
                        backgroundImage: `linear-gradient(to bottom,
                            rgba(118, 112, 255, 0) 3%,
                            #7670ff
                        ), url(${this.state.image})`,
                        backgroundSize: 'cover',
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'center',
                    }}
                ></div>
                <div className='article_container'>
                    <div className='title_container'>
                        {i18n.language === 'ar' ? (
                            <>
                                <p>{this.state.authorName}</p>
                                <h1>{this.state.title}</h1>
                                <h2>{this.state.subTitle}</h2>
                            </>
                        ) : (
                            <>
                                <p>{this.state.authorName}</p>
                                <h1>{this.state.title}</h1>
                                <h2>{this.state.subTitle}</h2>
                            </>
                        )}
                    </div>
                    {/* <a  href="https://twitter.com/share?ref_src=twsrc%5Etfw" class="twitter_btn" data-show-count="false" target="popup" onclick="window.open('../html-link.html','name','width=600,height=400')" >
                        <img src={twitter}/>
                    </a> */}

                    <div className='abstract_container'>
                        {i18n.language === 'ar' ? (
                            <p>{this.state.abstract}</p>
                        ) : (
                            <p>{this.state.abstract}</p>
                        )}
                    </div>

                    <div className='content_container'>
                        {!this.state.body ? (
                            <Loader
                                type='Grid'
                                color='#7670ff'
                                height={100}
                                width={100}
                                timeout={15000} //5 secs
                            />
                        ) : (
                            <>
                                {i18n.language === 'ar' ? (
                                    <p
                                        dangerouslySetInnerHTML={{
                                            __html: this.state.body,
                                        }}
                                    />
                                ) : (
                                    <p
                                        dangerouslySetInnerHTML={{
                                            __html: this.state.body,
                                        }}
                                    />
                                )}
                            </>
                        )}
                    </div>
                    <hr />
                    <div className='author_container'>
                        <div
                            className='author_image_container mx-3'
                            style={{
                                backgroundImage: `url(${this.state.authorAvatar})`,
                                backgroundSize: 'cover',
                                backgroundRepeat: 'no-repeat',
                                backgroundPosition: 'center',
                            }}
                        ></div>
                        <div className='author_info_container'>
                            <h2>{this.state.authorName}</h2>
                            <p>{this.state.authorTitle}</p>
                        </div>
                    </div>
                    <hr />
                    {this.state.file === null ? (
                        <></>
                    ) : (
                        <div className='parent_manual_container'>
                            <div
                                className='manual_image_container'
                                style={{
                                    backgroundImage: `url(${this.state.image})`,
                                    backgroundSize: 'cover',
                                    backgroundRepeat: 'no-repeat',
                                    backgroundPosition: 'center',
                                }}
                            ></div>
                            <div className='manual_info_container mx-4'>
                                {i18n.language === 'ar' ? (
                                    <>
                                        <p>{this.state.title}</p>
                                        <p>{this.state.subTitle}</p>
                                    </>
                                ) : (
                                    <>
                                        <p>{this.state.title}</p>
                                        <p>{this.state.subTitle}</p>
                                    </>
                                )}
                                <span>{filesize(this.state.fileSize)}</span>
                                <a href={`${this.state.file}`} target='_blank'>
                                    {t('download')}
                                </a>
                            </div>
                        </div>
                    )}

                    <div className='article-share'>
                        <FacebookShareButton url={url}>
                            <FacebookIcon size={26} round />
                        </FacebookShareButton>
                        <TelegramShareButton url={url}>
                            <TelegramIcon size={26} round />
                        </TelegramShareButton>
                        <TwitterShareButton url={url}>
                            <TwitterIcon size={26} round />
                        </TwitterShareButton>
                        <WhatsappShareButton url={url}>
                            <WhatsappIcon size={26} round />
                        </WhatsappShareButton>
                    </div>
                </div>
                <div
                    className={`related_articales_container ${
                        i18n.language === 'en' ? 'pl-60' : ''
                    }`}
                >
                    <h1>{t('related')}</h1>
                    <CardSlider arrow={arrow} cards={cards} full />
                </div>
                <FooterLarge minimal />
            </div>
        );
    }
}

export default withTranslation()(withRouter(ArticlesAndResearch));
